import {
  useBoundingClientRect,
  useWindowResize,
} from '@moneyforward/ap-frontend-components';
import { useMemo, useRef } from 'react';

export const useContainerHeight = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { innerHeight } = useWindowResize();
  const { top } = useBoundingClientRect(containerRef);

  // Use primitive values for memoization
  const height = top > 0 ? innerHeight - top : innerHeight;
  const containerStyle = useMemo(() => ({ height }), [height]);

  return { containerRef, containerStyle };
};
